import React, { useContext, useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import ProductController, {
  CategoryType,
  ProductType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { CurrentStoreContext } from '../../../controller/StoreController';

const CategoryIndex = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [categoryName, setCategoryName] = useState<string>('');
  const [categoryList, setCategoryList] = useState<CategoryType[]>([]);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const onChange_categoryName = (e: any) => {
    setCategoryName(e.target.value);
  };

  const navigateCategoryInfo = async (category_info?: CategoryType) => {
    if (category_info) {
      // const productInfo = await getSelectedProduct(product_id!);
      navigate(`/product/category/edit`, { state: { categoryInfo: category_info } });
    } else navigate(`/product/category/edit`);
  };

  // API 호출
  const getCategoryData = async () => {
    try {
      const oRes = await ProductController.getAllCateProduct(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCategoryData', oResponse);
        if (oResponse.data) {
          setCategoryList([...oResponse.data]);
          let openTemp = new Array(oResponse.data.length).fill(true);
          setIsOpen([...openTemp]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const setCategoryData = async () => {
    try {
      if (categoryName.length > 0) {
        const category = {
          name: categoryName,
          is_for_adult: 0,
          product_list: [],
        };
        const oRes = await ProductController.setCateProduct(currentStore.value, category);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log('setCateProduct', oResponse);
          if (oResponse.data && oResponse.ok) {
            showToast('새로운 상품분류를 만들었어요');
            getCategoryData();
            setCategoryName('');
          }
        }
      } else {
        showToast('상품분류명을 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const changeIndexCategoryData = async () => {
    try {
      const oRes = await ProductController.editCateProductIdOrder(currentStore.value, categoryList);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('editCateProductIdOrder', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('상품분류의 순서를 변경했어요');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, [currentStore]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > categoryList.length - 1) toIndex = categoryList.length;
    const newItems = [...categoryList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setCategoryList(newItems);
    setIsOpen(new Array(categoryList.length).fill(true));
  };

  interface DraggableItemProps {
    item: CategoryType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderCategory = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });

    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    const moveMenuItem = (mainIndex: number, fromIndex: number, toIndex: number) => {
      if (toIndex < 1) toIndex = 0;
      else if (toIndex > categoryList[mainIndex].product_list.length - 1)
        toIndex = categoryList[mainIndex].product_list.length;
      let newMainItems = [...categoryList];
      const newItems = [...newMainItems[mainIndex].product_list];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      newMainItems[mainIndex].product_list = newItems;
      setCategoryList(newMainItems);
    };

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <input
              ref={(node) => drag(drop(node))}
              value={selectedIndex}
              autoFocus={false}
              onChange={(e) => {
                setSelectedIndex(Number(e.target.value));
              }}
              onBlur={() => {
                moveItem(index, selectedIndex - 1);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  moveItem(index, selectedIndex - 1);
                }
              }}
            />
            <div className="row">
              <h3>{item.category_name}</h3>
              {item.is_for_adult === 1 && (
                <img src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`} alt="ic" />
              )}
            </div>
          </div>
          <div className="row gap">
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateCategoryInfo(item)}
            />
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            {item.product_list.map((subItem: ProductType, subIndex: number) => {
              return (
                <RenderMenuItem
                  key={`${index}_${subIndex}`}
                  mainIndex={index}
                  subItem={subItem}
                  subIndex={subIndex}
                  moveMenuItem={moveMenuItem}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  };

  interface DraggableMenuItemProps {
    subItem: ProductType;
    mainIndex: number;
    subIndex: number;
    moveMenuItem: (mainIndex: number, fromIndex: number, toIndex: number) => void;
  }

  const RenderMenuItem = ({
    subItem,
    mainIndex,
    subIndex,
    moveMenuItem,
  }: DraggableMenuItemProps) => {
    const [selectedMenuIndex, setSelectedMenuIndex] = useState<number>(subIndex + 1);

    const [, menuDrag] = useDrag({
      type: 'ITEM',
      item: { mainIndex, subItem, subIndex },
    });

    const [, menuDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { mainIndex: number; subIndex: number }, monitor: DropTargetMonitor) => {
        if (item.mainIndex === mainIndex && item.subIndex !== subIndex) {
          moveMenuItem(mainIndex, item.subIndex, subIndex);
          item.subIndex = subIndex;
        }
      },
    });

    return (
      <div className="menuItem" key={subIndex}>
        <div className="row">
          <input
            ref={(node) => menuDrag(menuDrop(node))}
            value={selectedMenuIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedMenuIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
              }
            }}
          />
          <div className="column">
            <div className="row">
              <h4>{subItem.prd_name}</h4>
              {subItem.is_set === 1 && <div className="setBadge">SET</div>}
            </div>
            <h5>{`${subItem.prd_base_price.toLocaleString()}원`}</h5>
          </div>
        </div>
        <div className="row">
          {subItem.url_path !== '' && subItem.url_path !== null && (
            <div className="imgWrap">
              <img src={subItem.url_path} alt="ic" />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <input
          type="text"
          value={categoryName}
          onChange={onChange_categoryName}
          placeholder="상품분류명을 적어주세요"
        />
        <button className="addButton" onClick={setCategoryData}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>상품분류 만들기</h4>
        </button>

        <div className="warningSign">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
          <div>
            <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
            <p>메뉴 순서를 변경할때는 동일한 상품분류 안에서만 이동이 가능합니다.</p>
          </div>
        </div>

        <DndProvider backend={HTML5Backend}>
          {categoryList.length > 0 ? (
            <div className="categoryList">
              {categoryList.map((item: CategoryType, index: number) => {
                return <RenderCategory key={index} item={item} index={index} moveItem={moveItem} />;
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>상품분류를 등록해주세요</h3>
            </div>
          )}
        </DndProvider>
        <button className={`submitButton`} onClick={changeIndexCategoryData}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default CategoryIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input {
    width: 100%;
    padding: 10px 12px 10px 20px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin: 10px 0;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      input {
        width: 30px;
        height: 30px;
        padding: 4px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        text-align: center;
        color: #40977f;
        background: #ecf5f3;
        border: 1px solid #4dd2ae;
        border-radius: 4px;
      }

      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }

      .loadButton {
        display: flex;
        align-items: center;
        border: 1px solid #4dd2ae;
        border-radius: 5px;
        padding: 4px 9px;
        gap: 4px;

        h5 {
          color: #40977f;
          font-weight: 600;
        }
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      flex-direction: column;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;

      .menuItem {
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 22px;
        border-bottom: 1px solid #f7f7f7;

        .setBadge {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50px;
          padding: 2px 10px;
          background: #ff7e7e;
          font-size: 12px;
          line-height: 16px;
          color: #ffffff;
          font-weight: 500;
        }

        input {
          width: 24px;
          height: 24px;
          padding: 4px;
          font-size: 14px;
          line-height: 16px;
          text-align: center;
          color: #979797;
          background: #ffffff;
          border: 1px solid #cecece;
          border-radius: 4px;
        }

        .column {
          gap: 2px;
          .row {
            gap: 8px;
          }
        }
        h4 {
          color: #555555;
          font-weight: 600;
        }
        h5 {
          color: #555555;
          font-weight: 400;
        }
        .row {
          gap: 20px;

          .imgWrap {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 60px;
            border-radius: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 5px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .categoryList {
      gap: 20px;

      .listItem {
        padding: 8px 10px 8px 16px;

        input {
          width: 26px;
          height: 26px;
          font-size: 14px;
        }
        h3 {
          font-size: 16px;
          color: #555555;
          font-weight: 600;
        }
      }

      .menuList {
        .menuItem {
          min-height: 50px;
          padding: 2px 16px;

          .setBadge {
            padding: 2px 8px;
            font-size: 12px;
            line-height: 14px;
          }
          input {
            width: 22px;
            height: 22px;
            padding: 4px;
            font-size: 12px;
            line-height: 14px;
          }

          .column {
            .row {
              gap: 6px;
            }
          }
          h4 {
            font-size: 14px;
            color: #555555;
            font-weight: 600;
          }
          h5 {
            font-size: 12px;
            color: #555555;
            font-weight: 400;
          }
          .row {
            gap: 14px;
            .imgWrap {
              width: 46px;
              height: 46px;
            }
          }
        }
      }
    }
  }
`;
